/* Generated from frontend/lib/seo/filter-robots.ts. Run pnpm build:filter-robots. */
/* Keep robots aligned with query parameters, including Section Rendering API navigation. */
(() => {
  const namespace = 'filter.p.m.storefront_filters';
  const isCollectionTemplate = !!document.querySelector('script[data-collection-template]');
  const selector = 'meta[name="robots" i], meta[name="googlebot" i]';
  const ownedSelector = 'meta[data-storefront-filter-robots]';
  const original = [...document.head.querySelectorAll(selector)]
    .filter((meta) => !meta.matches(ownedSelector))
    .map((meta) => meta.cloneNode(true));
  let filtered = false;
  const hasNoindexQuery = () =>
    [...new URLSearchParams(location.search).keys()].some(
      (key) =>
        key === namespace ||
        key.startsWith(`${namespace}.`) ||
        (isCollectionTemplate && (key === 'sort_by' || key === 'limit')),
    );
  const headObserver = new MutationObserver((records) => {
    if (
      records.some(
        (record) =>
          record.target instanceof HTMLMetaElement ||
          [...record.addedNodes, ...record.removedNodes].some(
            (node) => node instanceof HTMLMetaElement && node.matches(selector),
          ),
      )
    ) {
      syncRobots();
    }
  });
  /** Keep one noindex/follow directive for matching queries, restoring initial metadata on clear. */
  function syncRobots() {
    headObserver.disconnect();
    const metas = [...document.head.querySelectorAll(selector)];
    if (hasNoindexQuery()) {
      let robots = metas.find((meta) => meta.matches(ownedSelector));
      for (const meta of metas) {
        if (meta !== robots) meta.remove();
      }
      if (!robots) {
        robots = document.createElement('meta');
        robots.name = 'robots';
        robots.setAttribute('data-storefront-filter-robots', '');
        document.head.appendChild(robots);
      }
      robots.content = 'noindex, follow';
      filtered = true;
    } else if (filtered) {
      for (const meta of metas) meta.remove();
      for (const meta of original) document.head.appendChild(meta.cloneNode(true));
      filtered = false;
    } else {
      for (const meta of document.head.querySelectorAll(ownedSelector)) {
        meta.remove();
      }
    }
    headObserver.observe(document.head, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['name', 'content'],
    });
  }
  syncRobots();
  window.addEventListener('popstate', syncRobots);
  // The existing filter component updates the URL after swapping section content.
  // Observe that section so the same microtask sees the committed URL, without
  // patching history or rebuilding the unrelated application bundle.
  for (const section of document.querySelectorAll('[data-section-type="collection-grid"]')) {
    new MutationObserver(syncRobots).observe(section, { childList: true, subtree: true });
  }
})();
